@if (isModalOpen()) {
  <!-- Modal Overlay -->
  <div
    class="fixed inset-0 z-60 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 transition-opacity duration-300"
  >
    <!-- Modal Container -->
    <div
      class="bg-white rounded-xl shadow-2xl w-full max-w-lg flex flex-col overflow-hidden animate-in fade-in zoom-in duration-300"
    >
      <!-- Modal Header -->
      <header
        class="flex items-center justify-between p-4 sm:p-5 border-b border-gray-100"
      >
        <div class="flex items-center gap-x-2 text-[#1B596E]">
          <!-- Ticket Icon -->
          <svg
            class="size-6 stroke-current fill-none"
            viewBox="0 0 24 24"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M14.5 9a2.5 2.5 0 0 0-5 0v.5m2 5.5v-5m-7 5h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2V7a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2z"
            />
          </svg>
          <h2 class="font-bold text-lg">{{ 'selectShopVoucher' | translate }}</h2>
        </div>
        <button
          class="text-gray-400 hover:text-gray-800 transition-colors"
          (click)="onCloseModal()"
        >
          <svg
            class="size-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </header>

      <!-- Modal Body -->
      <div class="p-4 sm:p-5 bg-white">
        <!-- Manual Voucher Input -->
        <div class="flex items-stretch mb-6">
          <input
            type="text"
            [(ngModel)]="manualCode"
            [placeholder]="'enterVoucherCode' | translate"
            class="flex-1 border border-gray-200 rounded-l-md px-4 py-2 text-sm text-gray-700 outline-none focus:border-[#2899BB] focus:ring-1 focus:ring-[#2899BB] transition-colors"
          />
          <button
            (click)="onApplyManualCode()"
            [disabled]="isValidating() || !manualCode().trim()"
            class="bg-[#333333] capitalize hover:bg-[#1a1a1a] disabled:bg-gray-400 disabled:cursor-not-allowed text-white px-6 py-2 text-sm font-medium rounded-r-md transition-colors"
          >
            @if (isValidating()) {
              <span class="animate-pulse">{{ 'applying' | translate }}</span>
            } @else {
              {{ 'apply' | translate }}
            }
          </button>
        </div>

        @if (validationError()) {
          <div
            class="mb-4 p-3 bg-red-50 border border-red-200 rounded-md text-red-700 text-sm"
          >
            {{ validationError() }}
          </div>
        }

        <!-- Voucher List -->
        <div class="space-y-4 max-h-[55vh] overflow-y-auto pr-1 custom-scrollbar">
          @for (coupon of availableCoupons(); track coupon.couponId) {
            <article
              class="flex border border-gray-100 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 group bg-white h-28 w-full"
            >
              <!-- Left Edge - Generic style (category system removed per Open Question #1) -->
              <div
                class="relative w-14 flex items-center justify-center transition-colors bg-[#E5F1F6] text-[#4194A6]"
                style="
                  -webkit-mask-image: radial-gradient(
                    circle at 0px 50%,
                    transparent 12px,
                    black 12.5px
                  );
                  mask-image: radial-gradient(
                    circle at 0px 50%,
                    transparent 12px,
                    black 12.5px
                  );
                  -webkit-mask-size: 100% 36px;
                  mask-size: 100% 36px;
                  mask-repeat: repeat-y;
                  filter: drop-shadow(2px 0px 3px rgba(0, 0, 0, 0.15));
                "
              >
                <span
                  class="transform -rotate-90 tracking-[0.2em] text-2xs sm:text-xs font-bold uppercase whitespace-nowrap select-none pl-2"
                >
                  {{ 'coupon' | translate }}
                </span>
              </div>

              <!-- Middle Content: Details -->
              <div class="flex-1 py-3 px-4 flex flex-col justify-center">
                <h3
                  class="font-bold text-gray-900 text-sm sm:text-base group-hover:text-[#2899BB] transition-colors truncate"
                >
                  {{ coupon.code }}
                </h3>
                <p class="text-gray-500 text-xs mt-1 sm:text-sm line-clamp-2">
                  {{ formatDiscount(coupon) }}
                  @if (coupon.minimumSpend) {
                    <span>
                      • {{ 'minSpend' | translate }}:
                      {{ coupon.minimumSpend.toFixed(2) }}</span
                    >
                  }
                </p>
              </div>

              <!-- Right Action: Code & Button -->
              <div
                class="w-28 sm:w-36 py-3 px-3 flex flex-col items-center justify-center gap-y-2 border-l border-dashed border-gray-200"
              >
                <span
                  class="font-bold text-gray-800 text-xs sm:text-sm text-center w-full"
                >
                  {{ coupon.title }}
                </span>
                <button
                  (click)="onSelectCoupon(coupon)"
                  class="bg-[#2899BB] hover:bg-[#1E7792] text-white text-3xs sm:text-2xs font-medium py-1.5 px-3 rounded-md w-full transition-all duration-300 hover:shadow-md"
                >
                  {{ 'useCoupon' | translate }}
                </button>
              </div>
            </article>
          } @empty {
            <div class="text-center py-8 text-gray-500 text-sm">
              {{ 'noAvailableCoupons' | translate }}
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
